import React, { HTMLAttributes, ReactNode } from 'react'
import classNames from 'classnames'
import styles from './Card.module.css'

type CardProps = HTMLAttributes<HTMLElement> & {
    tag?: keyof JSX.IntrinsicElements
    children?: ReactNode
}

export const Card = ({ tag = 'section', children, className, ...rest }: CardProps) => {
    return React.createElement(tag, { ...rest, className: classNames(styles.root, className) }, children)
}
